import React from 'react';

export default function AdminSubscriptionConfig() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-slate-900">Subscription Config</h1>
        <p className="text-slate-600 mt-1">Configure subscription plans and pricing.</p>
      </div>
      <div className="rounded-xl border-2 border-dashed border-slate-200 bg-white/50 p-12 text-center">
        <p className="text-slate-500">Subscription configuration — start developing here.</p>
      </div>
    </div>
  );
}
